
import ImageSelector from '@/components/ImageSelector.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

@Component({
             components: {ImageSelector},
           })
export default class DlgEventSendEmail extends Vue {
  get valid() {
    return this.selectedTemplate !== '' && this.type > 0;
  }

  @Prop({type: Object, default: () => ({})}) public event!: any;
  @Getter('admin/events/templates') public templates!: any;

  public dialog: boolean = false;
  public loading: boolean = false;
  public selectedTemplate: string = '';
  public type: number = 1;

  @Action('admin/events/sendAllHostsMail') private sendAllHostsMail!: any;
  @Action('admin/events/sendAllGuestsMail') private sendAllGuestsMail!: any;
  @Action('admin/events/sendConfirmedGuestsMail') private sendConfirmedGuestsMail!: any;
  @Action('admin/events/sendPendingGuestsMail') private sendPendingGuestsMail!: any;
  @Action('admin/events/sendTestMail') private sendTestMail!: any;

  @Action('admin/events/sendToMissingReplies') private sendToMissingReplies!: any;
  @Action('admin/events/sendToAllDenies') private sendToAllDenies!: any;

  @Getter('common/rules/all') private rules!: any;

  public selectTemplate(template: any) {
    if (this.loading) {
      return;
    }
    this.selectedTemplate = template.id;
  }

  public async send() {
    this.loading = true;
    // TODO: send email
    switch (this.type) {
      case 1:
        await this.sendTestMail({eventId: this.event.id, templateId: this.selectedTemplate});
        break;
      case 2:
        await this.sendAllGuestsMail({eventId: this.event.id, templateId: this.selectedTemplate});
        break;
      case 3:
        await this.sendPendingGuestsMail({eventId: this.event.id, templateId: this.selectedTemplate});
        break;
      case 4:
        await this.sendConfirmedGuestsMail({eventId: this.event.id, templateId: this.selectedTemplate});
        break;
      case 5:
        await this.sendAllHostsMail({eventId: this.event.id, templateId: this.selectedTemplate});
        break;
      case 6:
        await this.sendToMissingReplies({eventId: this.event.id, templateId: this.selectedTemplate});
        break;
      case 7:
        await this.sendToAllDenies({eventId: this.event.id, templateId: this.selectedTemplate});
        break;
    }
    this.loading = false;
    this.type = 0;
    this.selectedTemplate = '';
    this.dialog = false;
  }

  private updated() {
    if (this.templates.length === 1) {
      this.selectedTemplate = this.templates[0].id;
    }
  }
}
